import { Component, Host, Prop, h, State, Listen, Watch } from "@stencil/core";

@Component({
    tag: "ux-iws-calculator",
    styleUrl: "calculator.scss",
})
export class NumberCalculator {
    private baseClass = "ux-iws-calculator";
    private targetAttribute: string = "data-ux-calculator";
    private valueAttribute: string = "data-ux-calculator-value";
    private typeAttribute: string = "data-ux-calculator-type";

    /** the initial value of the number */
    @Prop() initialValue: number = 0;
    /** sets the identifier of the calculator */
    @Prop() calculatorId: string = null;
    /** CSS classes to be given to the wrapper of the result number */
    @Prop() cssClasses: string = "";
    /** the locale to be passed to the number-format component. If not present will be taken from the browser */
    @Prop() locale: string = null;
    /** if set, this matrix array will be used */
    @Prop() matrix: any[] | true | null = null;

    @State() value: number = this.initialValue;

    componentWillLoad() {
        if (this.matrix === null) this.updateValue();
    }

    @Watch("matrix")
    @Listen("uxRadioButtonChange", { target: "window" })
    @Listen("uxCheckboxChange", { target: "window" })
    updateValue() {
        const calculatorElements = Array.from(
            document.querySelectorAll(`
            ux-checkbox[${this.targetAttribute}='${this.calculatorId}'],
            ux-radio-button[${this.targetAttribute}='${this.calculatorId}']
        `)
        );
        const checkedElements = calculatorElements.filter(
            (element: HTMLUxCheckboxElement | HTMLUxRadioButtonElement) => {
                const isHydrated = element.classList.contains("hydrated");
                return isHydrated
                    ? element.querySelector("input")?.checked
                    : element.checked;
            }
        );
        if (Array.isArray(this.matrix)) {
            const typeAttributes = [];
            for (let i = 0; i < checkedElements.length; i++) {
                const typeAttribute = checkedElements[i].getAttribute(
                    this.typeAttribute
                );
                const value = (checkedElements[i] as
                    | HTMLInputElement
                    | HTMLUxCheckboxElement
                    | HTMLUxRadioButtonElement).value;
                typeAttributes.push({ attr: typeAttribute, value });
            }
            const matrixElement = this.matrix.find((matrixValue) => {
                let match = true;
                typeAttributes.forEach((value) => {
                    if (matrixValue[value.attr] !== value.value) match = false;
                });
                return match;
            });
            if (matrixElement)
                this.value = this.initialValue + matrixElement.value;
            else {
                this.value = this.initialValue;
                console.warn(
                    `${this.baseClass}: could not find appropriate matrix element`
                );
            }
        } else {
            let sum: number = this.initialValue;
            for (let i = 0; i < checkedElements.length; i++) {
                const attributeValue = checkedElements[i].getAttribute(
                    this.valueAttribute
                );
                const parsedNumber = Number.parseFloat(attributeValue);
                if (!Number.isNaN(parsedNumber)) {
                    sum += parsedNumber;
                } else {
                    console.warn(
                        `${this.baseClass}: problem with parsing value attribute`
                    );
                }
            }
            this.value = sum;
        }
    }

    render() {
        return (
            <Host class={this.baseClass}>
                <slot name="prefix" />
                <ux-number-format
                    locale={this.locale || undefined}
                    class={this.cssClasses}
                    value={this.value}
                ></ux-number-format>
                <slot name="suffix" />
            </Host>
        );
    }
}
